<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher<{ close: void }>();
  
  let { prize = '' } = $props();
  
  let email = $state('');
  let name = $state('');
  let submitted = $state(false);
  let error = $state('');
  
  function handleSubmit() {
    if (!email || !name) {
      error = 'Please fill in all fields to claim your prize!';
      return;
    }
    
    if (!email.includes('@')) {
      error = 'Please enter a valid email address!';
      return;
    }
    
    submitted = true;
    error = '';
    
    const leads = JSON.parse(localStorage.getItem('leads') || '[]');
    leads.push({
      name,
      email,
      prize,
      timestamp: new Date().toISOString()
    });
    localStorage.setItem('leads', JSON.stringify(leads));
    
    setTimeout(() => {
      dispatch('close');
    }, 3000);
  }
  
  function handleClose() {
    dispatch('close');
  }
</script>

<div class="modal-overlay" onclick={handleClose}>
  <div class="modal-content" onclick={(e) => e.stopPropagation()}>
    {#if !submitted}
      <button class="close-btn" onclick={handleClose}>✕</button>
      
      <div class="modal-header">
        <span class="celebration-icon">🎉</span>
        <h2>CONGRATULATIONS!</h2>
        <p>You won: <strong class="prize-text">{prize}</strong></p>
      </div>
      
      <div class="modal-body">
        <p class="urgency-message">⚡ Enter your details NOW to claim your prize!</p>
        <p class="sub-message">This offer expires in <strong>5 minutes!</strong></p>
        
        <form onsubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          <div class="form-group">
            <label for="name">Full Name</label>
            <input 
              type="text" 
              id="name" 
              bind:value={name}
              placeholder="John Doe"
              required
            />
          </div>
          
          <div class="form-group">
            <label for="email">Email Address</label>
            <input 
              type="email" 
              id="email" 
              bind:value={email}
              placeholder="john@example.com"
              required
            />
          </div>
          
          {#if error}
            <p class="error-message">{error}</p>
          {/if}
          
          <button type="submit" class="claim-btn">
            🎁 CLAIM MY PRIZE NOW!
          </button>
          
          <p class="privacy-note">
            🔒 Your information is 100% secure. We never spam!
          </p>
        </form>
      </div>
    {:else}
      <div class="success-state">
        <span class="success-icon">✅</span>
        <h2>SUBMITTED!</h2>
        <p>Check your email for instructions to claim your <strong>{prize}</strong>!</p>
        <p class="thank-you">Thank you for playing! 🎰</p>
      </div>
    {/if}
  </div>
</div>

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  .modal-content {
    background: white;
    border-radius: 20px;
    max-width: 500px;
    width: 100%;
    position: relative;
    overflow: hidden;
    animation: slideUp 0.4s ease;
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  }
  
  @keyframes slideUp {
    from { transform: translateY(50px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  
  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #f0f0f0;
    border: none;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 1.2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
  }
  
  .close-btn:hover {
    background: #ff416c;
    color: white;
    transform: rotate(90deg);
  }
  
  .modal-header {
    background: linear-gradient(135deg, #f5af19, #f12711);
    color: white;
    padding: 40px 30px;
    text-align: center;
  }
  
  .celebration-icon {
    font-size: 4rem;
    display: block;
    margin-bottom: 10px;
    animation: bounce 0.6s ease infinite alternate;
  }
  
  @keyframes bounce {
    from { transform: translateY(0); }
    to { transform: translateY(-10px); }
  }
  
  .modal-header h2 {
    font-size: 2rem;
    margin-bottom: 10px;
    font-weight: 800;
  }
  
  .prize-text {
    font-size: 1.8rem;
    color: #FFD700;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  }
  
  .modal-body {
    padding: 30px;
  }
  
  .urgency-message {
    background: #fff3cd;
    border-left: 4px solid #ffc107;
    padding: 15px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #856404;
  }
  
  .sub-message {
    text-align: center;
    color: #666;
    margin-bottom: 25px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }
  
  .form-group input {
    width: 100%;
    padding: 15px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
    box-sizing: border-box;
  }
  
  .form-group input:focus {
    outline: none;
    border-color: #667eea;
  }
  
  .error-message {
    color: #ff416c;
    font-size: 0.9rem;
    margin-bottom: 15px;
    text-align: center;
  }
  
  .claim-btn {
    width: 100%;
    background: linear-gradient(45deg, #ff416c, #ff4b2b);
    color: white;
    border: none;
    padding: 18px;
    font-size: 1.3rem;
    font-weight: 700;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 5px 20px rgba(255, 75, 43, 0.4);
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  .claim-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(255, 75, 43, 0.6);
  }
  
  .claim-btn:active {
    transform: translateY(-1px);
  }
  
  .privacy-note {
    text-align: center;
    margin-top: 20px;
    font-size: 0.85rem;
    color: #999;
  }
  
  .success-state {
    padding: 60px 30px;
    text-align: center;
  }
  
  .success-icon {
    font-size: 5rem;
    display: block;
    margin-bottom: 20px;
  }
  
  .success-state h2 {
    font-size: 2rem;
    color: #667eea;
    margin-bottom: 15px;
  }
  
  .success-state p {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 10px;
  }
  
  .thank-you {
    margin-top: 20px;
    font-size: 1.3rem;
    font-weight: 600;
    color: #667eea;
  }
  
  @media (max-width: 480px) {
    .modal-header {
      padding: 30px 20px;
    }
    
    .modal-header h2 {
      font-size: 1.5rem;
    }
    
    .modal-body {
      padding: 20px;
    }
    
    .claim-btn {
      font-size: 1.1rem;
      padding: 15px;
    }
  }
</style>
